import { useEffect } from 'react';

export default function Sheet({
  title,
  subtitle,
  onClose,
  children,
  wide = false,
  variant = 'drawer',
  bodyClassName = '',
  className = '',
}) {
  const modal = variant === 'modal';

  useEffect(() => {
    function onKeyDown(event) {
      if (event.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', onKeyDown);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  return (
    <div
      className={modal ? 'sheet-scrim sheet-scrim-modal' : 'sheet-scrim'}
      onClick={onClose}
      role="presentation"
    >
      <aside
        className={[
          'sheet',
          wide ? 'sheet-wide' : '',
          modal ? 'sheet-modal' : '',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(event) => event.stopPropagation()}
      >
        <header className="sheet-head">
          <div className="sheet-head-copy">
            {subtitle ? <span className="kicker">{subtitle}</span> : null}
            <h2>{title}</h2>
          </div>
          <button type="button" className="sheet-close" onClick={onClose} aria-label="Close">
            <span className="material-symbol">close</span>
          </button>
        </header>
        <div className={['sheet-body', bodyClassName].filter(Boolean).join(' ')}>
          {children}
        </div>
      </aside>
    </div>
  );
}
